<template>
  <div class="d-flex justify-content-between align-items-center">
    <a v-if="printable.printable_pages && printable.printable_pages.length > 0"
      :href="'/api/pdf/' + printable.id + '?preview=true'"
      target="_blank"
      class="text-danger mr-1"
      v-tooltip="$t('preview')"
      @click.stop="">
      <fa :icon="['far','file-pdf']"
          transform="grow-6" />
    </a>
    <span class="text-secondary" v-tooltip="'Förhandsvisnings saknas'" v-else>
      <fa :icon="['far','file-pdf']"
          transform="grow-6" />
    </span> 

    <span>
      <a
        class="ml-2 text-success"  
        @click.stop="setApproval('approved')" 
        :disabled="hasApproved || !isAuditor"
        v-tooltip="getApprovalTooltip(printable)"
        v-if="printable.status == 'proof_client' && isAuditor && !hasApproved">
        <fa :icon="['fas','check']" /> 
        {{ (printable.approvals.approvals.length) + ' av ' + printable.approvals.auditors.length }}
      </a>
      <template v-else>
        <span class="ml-2 mr-1" :class="printable.is_approved && printable.approvals.auditors.length > 0 ? 'text-success' : 'text-muted' ">
          <fa :icon="['fas','check']" />
        </span>
        <span class="text-muted">
          {{ (printable.approvals.approvals.length) + ' av ' + printable.approvals.auditors.length }}
        </span>
      </template>
    </span>


    <a class="text-danger ml-2"  
        @click.stop="confirmStatus('Vill du verkligen återställa statusen?','constructing')" 
        v-if="canEdit && printable.status !== 'constructing'"
        v-tooltip="$t('reset')">
        <fa :icon="['fas','undo-alt']" class="mr-1" />
    </a>
    <span 
      v-else-if="canEdit && printable.status == 'constructing'" 
      @click.stop=""
      class="text-muted">
      <fa :icon="['fas','undo-alt']" class="mr-1" />
    </span>
  </div>
</template>

<script>
import store from "~/store";

import swal from "sweetalert2";
import axios from "axios";

export default {
  name: "PrintableTools",
  props: ["printable"],
  computed: {
    canEdit() {
      return store.getters["auth/user"]
        ? store.getters["auth/user"].role >= 3
        : -1;
    },
    hasApproved() {
      return this.printable.approvals.approvals.indexOf(this.currentUser) > -1;
    },
    isAuditor(){
        return this.printable.client_auditors.find(auditor => auditor.user.email == this.currentUser);
    }
  },
  methods: {
    getApprovalTooltip(printable){
      if(this.hasApproved || !this.isAuditor){
            return 'Inväntar godkännande (' + (printable.approvals.approvals.length) + ' av ' + printable.approvals.auditors.length + ')'
      } else {
            return 'Godkänn för tryck (' + (printable.approvals.approvals.length + 1) + ' av ' + printable.approvals.auditors.length + ')'
      }
    },
    confirmStatus(text, status) {
      let self = this;

      swal({
        title: text,
        text: this.$t("cant_undo"),
        type: "error",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: this.$t("reset"),
        confirmButtonClass: "bg-danger",
        cancelButtonText: this.$t("cancel")
      }).then(result => {
        if (result.value) {
          self.setStatus(status);
        }
      });
    },
    async setApproval(status){
        let params = {
            status: status
        };

        const { data } = await axios.post('/api/printable/' + this.printable.id + '/approve',params)
    },
    async setStatus(status) {
      let params = {
        status: status
      };

      const { data } = await axios.post(
        "/api/printable/" + this.printable.id + "/status",
        params
      );

      this.printable.status = status;

      this.$router.go(this.$router.currentRoute)
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/PrintableTools.vue